// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. USE component-icon/src/svgtoreact.sh TO MODIFY
import React from 'react';
import PropTypes from 'prop-types';

var Door = function Door(_ref) {
  var className = _ref.className,
      label = _ref.label;
  return (
    /*#__PURE__*/
    React.createElement("svg", {
      className: className,
      "aria-label": label,
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 16 16"
    },
    /*#__PURE__*/
    React.createElement("path", {
      d: "M13.39 1.339H2.58v12.14l8.346 1.951v-1.951h2.494V1.339zM7.675 8.926a1.166 1.166 0 011.084-1.084 1.084 1.084 0 11-1.084 1.084zm-.569-6.662h5.388v10.269h-1.567V3.181z"
    }))
  );
};

export default Door;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@cloudflare/component-icon/es/reactsvgs/Door.js
// module id = 998
// module chunks = 0